import { useState, useEffect } from "react";
import styles from './BookmarkButton.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as faBookmarkRegular } from '@fortawesome/free-regular-svg-icons';

function ShareButton({ facilityId, handleBookmark, bookmarkedFacilities }) {

  const [bookmarked, setBookmarked] = useState(false);

  useEffect(() => {
    const bookmarked = bookmarkedFacilities.includes(facilityId);
    if (bookmarked) {
      setBookmarked(true);
    }
  }, [bookmarkedFacilities, facilityId]);

  const bookMark = () => {
    setBookmarked(!bookmarked);
    handleBookmark(facilityId, !bookmarked);
  }
  
  return (
    <button className={`${styles.bookmarkButton} ${bookmarked ? styles.bookmarked : ''}`} onClick={bookMark} aria-label='この施設をブックマーク'>
        <FontAwesomeIcon icon={ bookmarked ? faBookmark : faBookmarkRegular} />
    </button>
  );
}

export default ShareButton;